<article>
  <!-- Structure de base, à adapter selon besoins -->
    <header class="home-page-ludo-card__title">
        <h2>{{ dataCard?.title }}</h2>
    </header>
    <div class="home-page-ludo-card__content">
      @if (dataCard?.image?.uri && isLearnerClass ) {
        <div class="home-page-ludo-card__content__image"
          [style.backgroundImage]="'url('+ dataCard?.image?.uri +')'">
        </div>
      }
        @if (dataCard?.description?.value && isParentClass) {
            <div class="home-page-ludo-card__content__body" [innerHTML]="dataCard?.description.value"></div>
        }
    </div>
    <footer class="home-page-ludo-card__actions">
        @if (dataCard?.image?.uri && isParentClass ) {
            <div class="home-page-ludo-card__content__image"
                 [style.backgroundImage]="'url('+ dataCard?.image?.uri +')'">
            </div>
        }

        @if (dataCard.link_label && dataCard.link_label !== '') {
            <button mat-button
                class="followed-list__card__actions--play"
                data-e2e="home-page-play-collection"
                (click)="onPlayLudoCard(dataCard)"
                role="button">
                <mat-icon aria-hidden="true" svgIcon="home-page-ludo-card-play"></mat-icon>
                <span>{{ dataCard.link_label }}</span>
            </button>
        }

    </footer>
</article>